import { isString } from 'angular';

export class VanTransfer {
  plate: string;
  model?: string;
  chassis?: Date;
  color?: string;
  localId?: number;
  deviceSerial: string[] | null;
  deviceModel?: string[] | null;
  devicesToInactive?: string | null;
  deviceSerialLastPosition: string | null;
  deviceSerialLastPositionHTML?: string;
  routes_id?: number | null | string;
  description?: string;
  isActive: boolean;
  email?: string;
  userCreateName?: string;
  userUpdateName?: string;
  createDate?: number;
  updateDate?: number;
  idUser?: number;

  constructor(
    item: {
      plate: string;
      model: string | undefined;
      chassis: Date | undefined;
      color: string | undefined;
      localId: number | undefined;
      deviceSerial: string[] | null;
      deviceModel: string[] | null;
      deviceSerialLastPosition: string | null;
      devicesToInactive: string | null;
      routes_id: number | null;
      description: string | undefined;
      isActive: boolean;
      email: string | undefined;
      userCreateName: string | undefined;
      userUpdateName: string | undefined;
      createDate: number | undefined;
      updateDate: number | undefined;
      idUser: number;
    } | null
  ) {
    if (item != null) {
      (this.plate = item.plate),
        (this.model = item.model),
        (this.chassis = item.chassis),
        (this.color = item.color),
        (this.localId = item.localId),
        (this.deviceSerial = item.deviceSerial),
        (this.deviceModel = item.deviceModel),
        (this.deviceSerialLastPosition = item.deviceSerialLastPosition),
        (this.devicesToInactive = item.devicesToInactive),
        (this.routes_id = item.routes_id),
        (this.description = item.description),
        (this.isActive = item.isActive),
        (this.email = item.email),
        (this.userCreateName = item.userCreateName),
        (this.userUpdateName = item.userUpdateName),
        (this.createDate = item.createDate),
        (this.updateDate = item.updateDate);
        (this.idUser = item.idUser);
    } else {
      (this.plate = ''),
        (this.isActive = false),
        (this.deviceSerial = null),
        (this.deviceSerialLastPosition = null);
    }
  }
}

export class VanTrasnferRoute {
  vanTransferPlate: string;
  routeId: string;
  email?: string;
  isActive?: boolean;
  create_time?: number;
  update_time?: number;
  userNameCreate?: string;
  userNameUpdate?: string;

  constructor() {
    (this.vanTransferPlate = ''), (this.routeId = 'null');
  }
}

export class VanTransferLocal {
  id: number;
  name: string;
  coordinates?: string;

  constructor() {
    (this.id = -1), (this.name = '');
  }
}

export class Areas {
  id: number;
  estimatedTime: number;
  order: string;
  message: string;
  coordinates: string;
  email?: string;
  create_time?: number;
  update_time?: number;
  userNameCreate?: string;
  userNameUpdate?: string;

  constructor() {
    (this.id = -1),
      (this.estimatedTime = 0),
      (this.order = '0'),
      (this.message = ''),
      (this.coordinates = '');
  }
}

export class Routes {
  id: number;
  localId: number | null;
  name: string;
  plates?: string;
  movidaCoordIcon: string;
  terminalsCoordIcons: string;
  routeMap: string;
  email?: string;
  isActive: boolean;
  create_time?: number;
  update_time?: number;
  userNameCreate?: string;
  userNameUpdate?: string;

  constructor() {
    (this.id = -1),
      (this.localId = null),
      (this.name = ''),
      (this.movidaCoordIcon = ''),
      (this.terminalsCoordIcons = ''),
      (this.routeMap = ''),
      (this.isActive = false);
  }
}

export class VanRoutes {
  plate: string;
  routes_id: number;
  email?: string;
  create_time?: number;
  update_time?: number;
  userNameCreate?: string;
  userNameUpdate?: string;
  constructor() {
    (this.plate = ''), (this.routes_id = -1);
  }
}

export class RoutesAreas {
  routes_id: number;
  area_id: number;
  email?: string;
  create_time?: number;
  update_time?: number;
  userNameCreate?: string;
  userNameUpdate?: string;

  constructor() {
    (this.routes_id = -1), (this.area_id = -1);
  }
}

export class Checklist {
  plate: string;
  checklistItem: ChecklistItem[];
  description: string;
  km: number | undefined;

  constructor(plate: string) {
    this.plate = plate;
    this.description = '';
    this.km = undefined;
    this.checklistItem = Object.values(ChecklistItemEnum)
      .filter((item) => typeof item === 'string')
      .map((item, id) => new ChecklistItem(item as ChecklistItemEnum, id));
  }
}

export class ChecklistItem {
  id: number;
  item: any;
  isOk: boolean | undefined;
  description: string;
  constructor(item: any, id: number) {
    this.id = id;
    this.item = item;
    this.isOk = undefined;
    this.description = '';
  }
}

export enum ChecklistItemEnum {
  'Parabrisas' = 1,
  'Palhetas' = 2,
  'Vidros' = 3,
  'Adesivos (Lataria e Vidros)' = 4,
  'Pneus',
  'Retrovisores',
  'Porta Traseira',
  'Porta Lateral',
  'Maçanetas',
  'Estribo',
  'Cinto de Segurança',
  'Ar Condicionado',
  'Rádio',
  'TV',
  'Freios',
  'Nível de Óleo',
  'Nível de Água (radiador)',
  'Água Reservatório Parabrisas',
  'Encosto de cabeça',
  'Farol',
  'Limpeza Geral',
}
